(() => { if (window.BEAEPAGEJS === undefined) {
            window.BEAEPAGEJS = [];
          }

          if(window.beaePageSetting == undefined) {
            window.beaePageSetting = {};
          }
          
          window.beaePageSetting.pageId = "68faa5694b89f9c9a50a6bd5";
              window.beaePageSetting.pageTitle = "Blogs"; 
              window.beaePageSetting.pageType = "blog";

          let js_EKIA1FF3 = () => { let BeaeUseHooks = {};
      try {
        let argid = 'beae-rc34hb2zsection-js',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-rc34hb2z',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-rc34hb2z');
        args.el = args.els[0];
        ((t) => { var o;if((o=t.el.querySelector(".beae-grid-system"))==null||o.addEventListener("scroll",a=>{var r,l;let n=a.target;if(!n.classList.contains("beae-grid-carousel"))return;let s=Math.round((n.scrollLeft+n.querySelector(".beae-grid-carousel__snaps").offsetLeft)/(n.offsetWidth*.8))+1;(r=t.el.querySelector(".beae-grid-carousel__pagination div.active"))==null||r.classList.remove("active"),(l=t.el.querySelector('.beae-grid-carousel__pagination div[data-index="'+s+'"]'))==null||l.classList.add("active")}),t.mode.value=="live"){const a=t.el.querySelector('.beae-section-background-video[data-device="desktop"]'),n=t.el.querySelector('.beae-section-background-video[data-device="mobile"]'),s=[];window.BEAEVIDEO&&window.BEAEVIDEO.convertBackgroundSection&&(window.innerWidth>=768?a&&window.BEAEVIDEO.convertBackgroundSection(t.optionsVideo,a)&&s.push("desktop"):n&&window.BEAEVIDEO.convertBackgroundSection(t.optionsVideoMobile,n)&&s.push("mobile")),(a||n)&&window.addEventListener("resize",()=>{if(window.BEAEVIDEO&&window.BEAEVIDEO.convertBackgroundSection){if(!s.includes("desktop")&&window.innerWidth>=768&&a){const r=window.BEAEVIDEO.convertBackgroundSection(t.optionsVideo,a);r&&(a.innerHTML=r.html,s.push("desktop"))}if(!s.includes("mobile")&&window.innerWidth<768&&n){const r=window.BEAEVIDEO.convertBackgroundSection(t.optionsVideoMobile,n);r&&(n.innerHTML=r.html,s.push("mobile"))}}})}t.el.querySelectorAll(".beae-text-highlight").forEach(a=>{new IntersectionObserver((s,r)=>{s.forEach(l=>{l.isIntersecting&&(l.target.querySelectorAll("path, line").forEach(c=>{c.style.strokeDasharray=parseFloat(c.getAttribute("data-dash-ratio")*l.target.offsetWidth*2)+"px, 999999px"}),r.unobserve(l.target))})},{root:document,rootMargin:"0px 0px -40%"}).observe(a)}) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-rc34hb2z: ', ex)
      };
    

      try {
        let argid = 'beae-8o10ozqublock-text',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-8o10ozqu',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-8o10ozqu');
        args.el = args.els[0];
        ((P) => { var I;let H=(I=P.el)==null?void 0:I.querySelectorAll(".beae-x-text a");H==null||H.forEach(z=>{let O=z==null?void 0:z.getAttribute("href");z&&P.mode.value!=="builder"&&(O!=null&&O.includes("#"))&&z.addEventListener("click",A=>{let D=document.querySelector(O+","+(O==null?void 0:O.replace("#",".")));if(D)return D.scrollIntoView({behavior:"smooth",block:"center",inline:"center"}),A.preventDefault(),!1})}) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-8o10ozqu: ', ex)
      };
    

      try {
        let argid = 'beae-m2juw9f8block-text',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-m2juw9f8',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-m2juw9f8');
        args.el = args.els[0];
        ((P) => { var I;let H=(I=P.el)==null?void 0:I.querySelectorAll(".beae-x-text a");H==null||H.forEach(z=>{let O=z==null?void 0:z.getAttribute("href");z&&P.mode.value!=="builder"&&(O!=null&&O.includes("#"))&&z.addEventListener("click",A=>{let D=document.querySelector(O+","+(O==null?void 0:O.replace("#",".")));if(D)return D.scrollIntoView({behavior:"smooth",block:"center",inline:"center"}),A.preventDefault(),!1})}) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-m2juw9f8: ', ex)
      };
    

      try {
        let argid = 'beae-qybl771vsection-js',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-qybl771v',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-qybl771v');
        args.el = args.els[0];
        ((t) => { var o;if((o=t.el.querySelector(".beae-grid-system"))==null||o.addEventListener("scroll",a=>{var r,l;let n=a.target;if(!n.classList.contains("beae-grid-carousel"))return;let s=Math.round((n.scrollLeft+n.querySelector(".beae-grid-carousel__snaps").offsetLeft)/(n.offsetWidth*.8))+1;(r=t.el.querySelector(".beae-grid-carousel__pagination div.active"))==null||r.classList.remove("active"),(l=t.el.querySelector('.beae-grid-carousel__pagination div[data-index="'+s+'"]'))==null||l.classList.add("active")}),t.mode.value=="live"){const a=t.el.querySelector('.beae-section-background-video[data-device="desktop"]'),n=t.el.querySelector('.beae-section-background-video[data-device="mobile"]'),s=[];window.BEAEVIDEO&&window.BEAEVIDEO.convertBackgroundSection&&(window.innerWidth>=768?a&&window.BEAEVIDEO.convertBackgroundSection(t.optionsVideo,a)&&s.push("desktop"):n&&window.BEAEVIDEO.convertBackgroundSection(t.optionsVideoMobile,n)&&s.push("mobile")),(a||n)&&window.addEventListener("resize",()=>{if(window.BEAEVIDEO&&window.BEAEVIDEO.convertBackgroundSection){if(!s.includes("desktop")&&window.innerWidth>=768&&a){const r=window.BEAEVIDEO.convertBackgroundSection(t.optionsVideo,a);r&&(a.innerHTML=r.html,s.push("desktop"))}if(!s.includes("mobile")&&window.innerWidth<768&&n){const r=window.BEAEVIDEO.convertBackgroundSection(t.optionsVideoMobile,n);r&&(n.innerHTML=r.html,s.push("mobile"))}}})}t.el.querySelectorAll(".beae-text-highlight").forEach(a=>{new IntersectionObserver((s,r)=>{s.forEach(l=>{l.isIntersecting&&(l.target.querySelectorAll("path, line").forEach(c=>{c.style.strokeDasharray=parseFloat(c.getAttribute("data-dash-ratio")*l.target.offsetWidth*2)+"px, 999999px"}),r.unobserve(l.target))})},{root:document,rootMargin:"0px 0px -40%"}).observe(a)}) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-qybl771v: ', ex)
      };
    

      try {
        let argid = 'beae-w9azml8tsection-blog-posts-page',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-w9azml8t',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-w9azml8t');
        args.el = args.els[0];
        ((a) => { var f;n();function n(){document.querySelectorAll(".beae-blog-paginate--wrp a").forEach(C=>{(!C.hasAttribute("href")||!C.getAttribute("href").trim())&&(C.addEventListener("click",function(g){g.preventDefault()}),C.classList.add("disabled"),C.style.pointerEvents="none",C.style.opacity="0.5")})}const t=window.location.search,o="/blogs/"+((f=a.blog)==null?void 0:f.handle),r=a.el.querySelectorAll(".beae-blog-list button.beae-blog-btn"),s=a.el.querySelectorAll(".beae-blog-list button.beae-blog-tag-btn");r.length>0&&y(r,t),s.length>0&&y(s,t,o),x();const u=a.el.querySelector(".beae-x-blog-posts-page"),c=u.getAttribute("section-template-id").split("__")[1],d=new URLSearchParams(window.location.search);let l=!1;!d.has("view")&&r.length>0&&(l=!0);function y(b,C="",g=""){if(b.length){const v=window.location.pathname;b.forEach(S=>{S.getAttribute("data-url")===v&&S.classList.add("active"),S.addEventListener("click",function(B){var w;b.forEach(_=>{_.classList.remove("active")}),S.classList.add("active");const k=g+((w=S.getAttribute("data-url"))==null?void 0:w.replace(" ","-"));if(!k)return;const $=new URL(window.location.origin+k+C);p($.href)})})}}function x(){const b=document.querySelectorAll(".beae-blog-paginate .beae-blog-pagination-btn");b.length&&b.forEach(C=>{C.addEventListener("click",function(g){const v=C.getAttribute("data-url");if(!v)return;const S=new URL(window.location.origin+v);p(S.href)})})}let m={};function h(b,C){return new Promise(g=>{const v=a.el.querySelector(C),S=document.createElement("div");S.innerHTML=b;const B=S.querySelector(C);v&&(v.style.height="fit-content",B?v.innerHTML=B.innerHTML:(v.style.height="0px",v.style.overflow="hidden")),g()})}function p(b){if(m={},!u)return;const C=u.getAttribute("section-template-id"),g=new URL(b);let v=g.search?g.search.replace("?",""):"";const S=g.pathname+"?section_id="+C+"&"+v;fetch(S).then(B=>B.text()).then(B=>{m[S]=B,h(B,".beae-x-blog-posts"),h(B,".beae-blog-paginate"),x()}),l&&(v+=v.length>0?"&view="+c:"view="+c),history.pushState({searchParams:v},"",`${g.pathname}${v&&"?".concat(v)}`)} })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-w9azml8t: ', ex)
      };
    

      try {
        let argid = 'beae-3w5yqgvlblock-developer',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-3w5yqgvl',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-3w5yqgvl');
        args.el = args.els[0];
        ((data
) => { data.el.querySelectorAll('.beae-blog-tag-btn').forEach(button => {
    const url = button.getAttribute('data-url');
    if (url === '/tagged/') {
      button.setAttribute('data-url', '/');
    
    }
    if (button.getAttribute('data-url') === '/') {
      button.classList.add('active');
    }
  }); })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-3w5yqgvl: ', ex)
      };
    

      try {
        let argid = 'beae-tdts61lxblock-image',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-tdts61lx',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-tdts61lx');
        args.el = args.els[0];
        ((M) => { var P;if(M.el){if(M.shape){const O=M.el.closest(".beae-slider-items");O&&!O.hasAttribute("data-svg")&&(O==null||O.closest(".beae-section").insertAdjacentHTML("beforeend",`
                            <svg width="0" height="0" style="height: 0px !important; width: 0px !important; opacity: 0 !important;">
                            <defs>
                                <clipPath id="shape-${M.id}" clipPathUnits="objectBoundingBox">
                                ${M.shape.clipPath}
                                </clipPath>
                            </defs>
                            </svg>
                        `),O.setAttribute("data-svg","true"))}let H=M.el.querySelector(".beae-image-content-position"),I,z=window.innerWidth>=768&&M.autoHover;var V=H.querySelector(".beae-img-ratio-control"),L=H.querySelector(".beae-img-comp-container"),T=H.querySelector(".beae-img-comp-container--second");if(V&&T){let O=function(A){let D=0,Z;q(),z?H.onmouseover=function(G){W(G)}:A.onmousedown=function(G){W(G)},H.onmouseup=function(){j()},A.ontouchstart=function(G){W(G)},H.ontouchend=function(){j()};function q(){new ResizeObserver(()=>{window.requestAnimationFrame(()=>{I=T.offsetWidth})}).observe(T),A.style.left&&parseInt(A.style.left)}function W(G){check=!1,G.preventDefault(),G.clientX?G.clientX:G.touches[0].clientX,parseInt(A.style.left),D=1,H.onmousemove=function(X){R(X)},H.ontouchmove=function(X){R(X)}}function j(){D=0,check=!0}function R(G){if(D==0)return!1;Z=U(G),Z<0&&(Z=0),Z>100&&(Z=100),F(Z)}function U(G){const X=H.getBoundingClientRect(),ie=(G.changedTouches?G.changedTouches[0].clientX:G.clientX)-X.left;return Math.max(0,Math.min(100,Math.round(ie*100/I)))}function F(G){A.style.left=G+"%",T.style.clipPath=`polygon(${G}% 0%, ${G}% 100%, 100% 100%, 100% 0)`,L.style.clipPath=`polygon(0% 100%, 0% 0%, ${G}% 0%, ${G}% 100%)`}};V&&T&&O(V),window.addEventListener("resize",function(){V&&T&&(new ResizeObserver(()=>{window.requestAnimationFrame(()=>{I=T.offsetWidth})}).observe(T),O(V))})}}let N=(P=M.el)==null?void 0:P.querySelector("a.beae-x-image"),E=N==null?void 0:N.getAttribute("href");N&&M.mode.value!=="builder"&&(E!=null&&E.includes("#"))&&N.addEventListener("click",H=>{let I=document.querySelector(E+","+(E==null?void 0:E.replace("#",".")));if(I)return I.scrollIntoView({behavior:"smooth",block:"center",inline:"center"}),H.preventDefault(),!1}) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-tdts61lx: ', ex)
      };
    

      try {
        let argid = 'beae-fg5scmq4block-text',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-fg5scmq4',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-fg5scmq4');
        args.el = args.els[0];
        ((P) => { var I;let H=(I=P.el)==null?void 0:I.querySelectorAll(".beae-x-text a");H==null||H.forEach(z=>{let O=z==null?void 0:z.getAttribute("href");z&&P.mode.value!=="builder"&&(O!=null&&O.includes("#"))&&z.addEventListener("click",A=>{let D=document.querySelector(O+","+(O==null?void 0:O.replace("#",".")));if(D)return D.scrollIntoView({behavior:"smooth",block:"center",inline:"center"}),A.preventDefault(),!1})}) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-fg5scmq4: ', ex)
      };
    

      try {
        let argid = 'beae-wl9sh4w3block-text',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-wl9sh4w3',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-wl9sh4w3');
        args.el = args.els[0];
        ((P) => { var I;let H=(I=P.el)==null?void 0:I.querySelectorAll(".beae-x-text a");H==null||H.forEach(z=>{let O=z==null?void 0:z.getAttribute("href");z&&P.mode.value!=="builder"&&(O!=null&&O.includes("#"))&&z.addEventListener("click",A=>{let D=document.querySelector(O+","+(O==null?void 0:O.replace("#",".")));if(D)return D.scrollIntoView({behavior:"smooth",block:"center",inline:"center"}),A.preventDefault(),!1})}) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-wl9sh4w3: ', ex)
      };
    

      try {
        let argid = 'beae-7a534hgublock-text',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-7a534hgu',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-7a534hgu');
        args.el = args.els[0];
        ((P) => { var I;let H=(I=P.el)==null?void 0:I.querySelectorAll(".beae-x-text a");H==null||H.forEach(z=>{let O=z==null?void 0:z.getAttribute("href");z&&P.mode.value!=="builder"&&(O!=null&&O.includes("#"))&&z.addEventListener("click",A=>{let D=document.querySelector(O+","+(O==null?void 0:O.replace("#",".")));if(D)return D.scrollIntoView({behavior:"smooth",block:"center",inline:"center"}),A.preventDefault(),!1})}) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-7a534hgu: ', ex)
      };
    }; if (window.BEAEBASE) {js_EKIA1FF3()} else {window.BEAEPAGEJS.push(js_EKIA1FF3)} })(); 